import {
  TherapistSearchRequestDtoOrderEnum,
  TherapistSearchRequestDtoOrderTermsEnum,
} from '@app/api';
import { AllTherapistsTab } from './AllTherapists/AllTherapists';

export enum DayLimitEnum {
  Today = 'Ближайшие 24 часа',
  ThreeDays = 'Ближайшие 3 дня',
  Week = 'Ближайшая неделя',
  Month = 'Ближайший месяц',
  NoMatter = 'Не важно',
}

export enum PriceEnum {
  To3000 = 'До 3.000 руб',
  To4000 = 'До 4.000 руб',
  To5000 = 'До 5.000 руб',
  To8000 = 'До 8.000 руб',
  from8000 = 'От 8.000 руб и более',
}

export interface ConvertAppliedFiltersToQueryParams {
  selectedFiltersValues: any;
  selectedFiltersDiseases: string[] | string;
  selectedSorting?: {
    order?: TherapistSearchRequestDtoOrderEnum;
    orderTerms?: TherapistSearchRequestDtoOrderTermsEnum;
  };
  page: number;
  tab?: AllTherapistsTab;
  searchValue?: string;
  childOld?: number | undefined;
  therapistOld?: string | undefined;
}
